import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "ng2-translate/ng2-translate";
@Pipe({ name: "TransStatus" })
export class TransStatusPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(value: any): any {
    if (value !== undefined && value !== null && value !== "") {
      const convertValue = "TransactionList_" + value;

      let x = this.translate.instant(convertValue).toString();

      return this.translate.instant(convertValue).toString();
    }
  }
}

@Pipe({ name: "linkify" })
export class LinkifyPipe implements PipeTransform {
  transform(link: string): string {
    return this.linkify(link);
  }

  private linkify(plainText): string {
    let replacedText;
    let replacePattern1;
    let replacePattern2;
    let replacePattern3;
    let replacePattern4;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = plainText.replace(
      replacePattern1,
      '<a class="blue" href="$1" target="_blank">$1</a>'
    );

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '$1<a class="blue" href="http://$2" target="_blank">$2</a>'
    );

    //Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a class="blue" href="mailto:$1">$1</a>'
    );
    //Change phone number to tel:: links.

    replacePattern4 = /(^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[789]\d{9}|(\d[ -]?){10}\d$)/gim;
    let isDotAvalaibable = false;
    if (
      replacedText.substring(replacedText.length - 1, replacedText.length) ==
      "."
    ) {
      replacedText = replacedText.substring(0, replacedText.length - 1);
      isDotAvalaibable = true;
    }
    replacedText = replacedText.replace(
      replacePattern4,
      '<a class="blue" href="tel:$1" rel="nofollow">$1</a>'
    );
    if (isDotAvalaibable) {
      replacedText += ".";
    }
    return replacedText;
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/TranscationStatus.ts